export function getObjectLength<T extends object>(object: T) {
    return Object.keys(object).length;
}
